<app-charge-widget
	[widgetIcon]="{
		mobile: './assets/images/icons/education.svg',
		backgroundColor: '#f03b23',
	}"
	[widgetTitle]="'Образование (г.&nbsp;Москва)'"
	[charges]="charges"
	[subscriptionsAbsence]="subscriptionsAbsence"
	(addSubscriptionClick)="onAddSubscriptionClick()"
	(tabSearchActivate)="onTabSearchActivate()"
	(tabSubscriptionActivate)="onTabSubscriptionActivate()"
>
	<div class="widget-field-wrapper">
		<p class="widget-field-wrapper__title">Поиск начислений по УИН или документам</p>
		<app-form-field
			[fieldFormControl]="searchFormNew.getControlFromAllLevels('typeSelect')!!"
		></app-form-field>
		<div class="widget-field-wrapper__search-wrapper">
			<div class="widget-field-wrapper__search-input">
				@if (searchFormNew.get('typeSelect')?.value === 'BIRTH_CERTIFICATE') {
					<app-birth-certificate-field
						[fieldFormControl]="searchFormNew.getFieldFormControl('birthCertificate')!"
					></app-birth-certificate-field>
				} @else {
					<app-form-field
						[fieldFormControl]="searchFormNew.getFieldFormControl('searchText')!"
					></app-form-field>
				}
			</div>

			<button
				class="button-reset widget-field-wrapper__search-button"
				[disabled]="
					searchFormNew.get('typeSelect')?.value === 'BIRTH_CERTIFICATE'
						? searchFormNew.get('birthCertificate')?.invalid ||
							searchFormNew.get('birthCertificate')?.pristine
						: searchFormNew.get('searchText')?.invalid ||
							searchFormNew.get('searchText')?.pristine
				"
				(click)="search()"
				type="button"
			>
				<app-svg-search-magnifying-glass
					width="20px"
					height="20px"
				></app-svg-search-magnifying-glass>
			</button>
		</div>
	</div>
</app-charge-widget>
